/**
 * 오더 목록 모달 (공용) — $j.F.Admin.Order.OrderListModal
 *
 * 회원이 발주/수주한 오더 목록을 동일한 표(JBModal + DataTable)로 띄운다.
 * heavy 발주자 통계(HeavyBaljooja)·매칭 성과(MatchStat) 등에서 공유.
 *
 * 행(row) 형태(서버 가공): { num, work_day, car_type, car_range_str, sigungu,
 *                          car_price, order_status, owner_name|bal_owner_name }
 *
 * 사용법:
 *   $j.F.Admin.Order.OrderListModal.show('hb-orders-modal', title, rows, {
 *       lastColTitle: '발주자', lastColField: 'bal_owner_name', lastColNoField: 'order_owner_num',
 *       emptyName: '-', navHtml: '<...이전/다음 버튼...>', pageLength: 10,
 *   });
 *
 * lastColNoField 를 주면 마지막 칸을 관리자 회원 표기(`이름#번호` + 회원 팝오버)로 그린다.
 * 행에 그 번호가 없으면(0) 이름만 적는다.
 */
import Util from '../../../Common/Util';

export default class OrderListModal {

    /** 오더 상태 배지 */
    static status(s) {
        const M = (typeof G5 !== 'undefined' && G5['ORDER_STATUS']) || {}; // 정본: PHP G5_ORDER_STATUS
        const n = Number(s);
        const label = M[n] || s;
        const color = n === 99 ? '#dc3545' : (n >= 8 ? '#198754' : (n >= 6 ? '#0d6efd' : '#6c757d'));
        return `<span class="badge" style="background:${color};color:#fff;">${label}</span>`;
    }

    /**
     * 오더 목록 모달 표시.
     * @param {string} modalId  JBModal id
     * @param {string} title    모달 제목 (텍스트 — 회원명이 들어가므로 여기서 이스케이프한다)
     * @param {Array}  rows     오더 행 배열
     * @param {object} opts     { lastColTitle, lastColField, emptyName, navHtml, width, pageLength, emptyText }
     * @returns {object|null}   DataTable 인스턴스
     */
    static show(modalId, title, rows, opts = {}) {
        const o = {
            lastColTitle: '수주자', lastColField: 'owner_name', lastColNoField: '', emptyName: '미배차',
            navHtml: '', width: '860px', pageLength: 10, emptyText: '오더 없음', ...opts,
        };
        this.destroy();

        const tblId = `${modalId}-tbl`;
        const html = `<div>${o.navHtml}<table id="${tblId}" class="table table-sm table-bordered display" style="width:100%;"></table></div>`;
        $j.Ui.JBModal.html(modalId, html, Util.escapeHtml(title), { width: o.width });

        if (!document.getElementById(tblId)) return null;
        const Self = this;
        this._table = new DataTable(`#${tblId}`, {
            data: rows || [],
            columns: [
                { data: 'num', title: '오더' },
                { data: 'work_day', title: '작업일' },
                { data: null, title: '장비', render: (r) => [r.car_type, r.car_range_str].filter(Boolean).join(' ') || '-' },
                { data: 'sigungu', title: '현장', render: (v) => Util.escapeHtml(v || '-') },
                { data: 'car_price', title: '금액', className: 'text-right', render: (v) => Number(v || 0).toLocaleString() },
                { data: 'order_status', title: '상태', render: (v) => Self.status(v) },
                { data: o.lastColField, title: o.lastColTitle, render: (v, t, r) => {
                    const no = o.lastColNoField ? Number(r[o.lastColNoField]) || 0 : 0;
                    if (no) return $j.F.Admin.Member.Pop.cell(no, v);
                    return v ? Util.escapeHtml(v) : `<span class="text-muted">${o.emptyName}</span>`;
                } },
            ],
            order: [[1, 'desc']], // 작업일 최신순
            pageLength: o.pageLength,
            lengthChange: false,
            searching: true,
            autoWidth: false,
            language: { emptyTable: o.emptyText },
        });
        return this._table;
    }

    static destroy() {
        if (this._table) { try { this._table.destroy(); } catch (e) { /* noop */ } this._table = null; }
    }
}
